import { Pipe, PipeTransform } from '@angular/core'
import moment from 'moment'

@Pipe({
  name: 'dayName',
  standalone: true,
})
export class DayNamePipe implements PipeTransform {
  transform(dayOffset: number, locale?: string): string {
    const targetDay = moment().add(dayOffset, 'days')
    if (locale) {
      targetDay.locale(locale)
    }
    return targetDay.format('ddd DD MMM').toUpperCase()
  }
}
